import { useFormikContext } from "formik";
import { EICFormData } from "./types";

export const useAccountTypeHandler = () => {
  const { values, setValues, setErrors } = useFormikContext<EICFormData>();

  const PAGE_TWO_FIELDS = [
    "firstName",
    "lastName",
    "dateOfBirth",
    "phone",
    "email",
    "companyName",
    "abn",
    "addSecondaryAccountHolder",
    "addSecondaryToBills",
    "secondaryFirstName",
    "secondaryLastName",
    "secondaryDateOfBirth",
    "secondaryPhone",
    "secondaryEmail",
  ];

  const DATE_FIELDS = ["dateOfBirth", "secondaryDateOfBirth"];
  const BOOLEAN_FIELDS = ["addSecondaryAccountHolder", "addSecondaryToBills"];

  const resetPageTwoFields = () => {
    const resetValues = PAGE_TWO_FIELDS.reduce((acc, field) => {
      if (DATE_FIELDS.includes(field)) {
        acc[field] = null;
      } else if (BOOLEAN_FIELDS.includes(field)) {
        acc[field] = false;
      } else {
        acc[field] = "";
      }
      return acc;
    }, {} as any);

    return resetValues;
  };

  const handleAccountTypeChange = (newAccountType: string) => {
    setValues({
      ...values,
      accountType: newAccountType,
      ...resetPageTwoFields(),
    });
    setErrors({});
  };

  return { handleAccountTypeChange };
};
